import './RatesList.sass';

import * as React from 'react';
import { connect } from 'react-redux';

import { getPermissions, getUser } from '../../components/Login/selectors';
import NumberUtils from '../../lib/NumberUtils';
import RateLine from './RateLine';

class RatesList extends React.Component {
  render() {
    const {
      title,
      rates,
      selected,
      onRateClick,
      onPlusClick,
      permissions,
      user,
    } = this.props;

    const pfe = rates.find((rate) => rate.isPfeOnly);

    return (
      <div className="rates-list-component">
        {(title || onPlusClick) && (
          <div className="rates-title">
            {title}
            {onPlusClick && (
              <i className="fa fa-plus fa-lg mt-1" onClick={onPlusClick} />
            )}
            <div className="line-quals-page" />
          </div>
        )}
        <div className="rates-list">
          {pfe && (
            <div>
              <RateLine
                onClick={() => onRateClick(pfe)}
                name={`${pfe.name}`}
                selected={selected && pfe.id === selected.id}
                pfe
              />
              <hr />
            </div>
          )}
          {rates.length ? (
            rates
              .filter((rate) => !rate.isPfeOnly)
              .map((rate) => (
                <div className="row" key={NumberUtils.obtainUniqueKey()}>
                  <RateLine
                    onClick={() => onRateClick(rate)}
                    name={`${rate.name} ${
                      rate.shortname ? `(${rate.shortname})` : ''
                    }`}
                    selected={selected && rate.id === selected.id}
                    pfe={false}
                    id={rate.id}
                  />
                </div>
              ))
          ) : (
            <p>No AFSCs</p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  permissions: getPermissions(state),
  user: getUser(state),
});

export default connect(mapStateToProps)(RatesList);
